import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Nav from '../../components/Nav';
import Header from '../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getClients } from '../../redux/actions/client.action';
import { setLoading } from '../../redux/actions/loader.action';
import { endpoint, endpointApi } from '../../utils';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';
import Paginate from '../../components/Paginate';

export default function ClientsPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const clients = useSelector(state => state.clients);
    const { me } = useSelector(state => state.auth);

    const modalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const fileRef = useRef(null);
    const [client, setClient] = useState(null);
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);
    
    const [ids, setIds] = useState([]);
    const checkboxRefs = useRef([]);

    const [code, setCode] = useState("");
    const [photo, setPhoto] = useState("");
    const [type, setType] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [rcs, setRcs] = useState("");
    const [nif, setNif] = useState("");
    const [stat, setStat] = useState("");
    const [cif, setCif] = useState("");
    const [gender, setGender] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [website, setWebsite] = useState("");
    const [isCodeTouched, setIsCodeTouched] = useState(false);
    const [isTypeTouched, setIsTypeTouched] = useState(false);
    const [isCompanyNameTouched, setIsCompanyNameTouched] = useState(false);
    const [isRcsTouched, setIsRcsTouched] = useState(false);
    const [isNifTouched, setIsNifTouched] = useState(false);
    const [isStatTouched, setIsStatTouched] = useState(false);
    const [isCifTouched, setIsCifTouched] = useState(false);
    const [isGenderTouched, setIsGenderTouched] = useState(false);
    const [isFirstnameTouched, setIsFirstnameTouched] = useState(false);
    const [isPhoneTouched, setIsPhoneTouched] = useState(false);
    const [isEmailTouched, setIsEmailTouched] = useState(false);
    const [isAddressTouched, setIsAddressTouched] = useState(false);
    const [isZipcodeTouched, setIsZipcodeTouched] = useState(false);
    const [isCityTouched, setIsCityTouched] = useState(false);
    const [isCountryTouched, setIsCountryTouched] = useState(false);
    const [isWebsiteTouched, setIsWebsiteTouched] = useState(false);
    const [errors, setErrors] = useState(null);

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;

        if(checked){
            setIds((prevValues) => [...prevValues, value]);
        }else{
            setIds((prevValues) => prevValues.filter((item) => item !== value));
        }
    }

    useEffect(() => {
        dispatch(getClients(location, navigate));
    }, [location, dispatch, navigate]);

    const handlePhotoChange = (e) => {
        const selectedPhoto = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result;
            setPhoto(base64String);
        };
    
        if (selectedPhoto) {
            reader.readAsDataURL(selectedPhoto);
        }
    }

    const _close = useCallback(() => {
        setModal(null);
        setCode("");
        setPhoto("");
        setType("");
        setCompanyName("");
        setRcs("");
        setNif("");
        setStat("");
        setCif("");
        setGender("");
        setFirstname("");
        setLastname("");
        setPhone("");
        setEmail("");
        setAddress("");
        setZipcode("");
        setCity("");
        setCountry("");
        setWebsite("");
        setIsCodeTouched(false);
        setIsTypeTouched(false);
        setIsCompanyNameTouched(false);
        setIsRcsTouched(false);
        setIsNifTouched(false);
        setIsStatTouched(false);
        setIsGenderTouched(false);
        setIsFirstnameTouched(false)
        setIsPhoneTouched(false);
        setIsEmailTouched(false);
        setIsAddressTouched(false);
        setIsZipcodeTouched(false);
        setIsCityTouched(false);
        setIsCountryTouched(false);
        dispatch(setLoading(false));
        setErrors(null);

        if(fileRef.current)
            fileRef.current.value = null;
    
        setTimeout(() => {
          setClient(null);
        }, 200);
    }, [dispatch]);

    const close = useCallback((e) => {
        if(modalRef.current === e.target || detailsModalRef.current === e.target || e.target.classList.contains('_modal-close')){
          _close();
        }
    }, [_close]);

    useEffect(() => {
        document.addEventListener('click', close);
        return () => {
            document.removeEventListener('click', close);
        }
    }, [close]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);
    
    useEffect(() => {
        if(client){
            setCode(client.code ? client.code : "");
            setType(client.type ? client.type : "");
            setCompanyName(client.company_name ? client.company_name : "");
            setRcs(client.rcs ? client.rcs : "");
            setNif(client.nif ? client.nif : "");
            setStat(client.stat ? client.stat : "");
            setCif(client.cif ? client.cif : "");
            setGender(client.gender ? client.gender : "");
            setFirstname(client.first_name ? client.first_name : "");
            setLastname(client.last_name ? client.last_name : "");
            setPhone(client.phone ? client.phone : "");
            setEmail(client.email ? client.email : "");
            setAddress(client.address ? client.address : "");
            setZipcode(client.zipcode ? client.zipcode : "");
            setCity(client.city ? client.city : "");
            setCountry(client.country ? client.country : "");
            setWebsite(client.website ? client.website : "");
        }
    }, [client]);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        if("add" === modal){
            await axios.post(`${ endpointApi }clients`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${ jwt_access}`
                }
            }).then(({ data }) => {
                dispatch(getClients(location, navigate));
                setClient(data);
                setModal('details');
                setPhone('');
                if(fileRef.current)
                    fileRef.current.value = null;
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }else{
            await axios.post(`${ endpointApi }clients/${ client.id }`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${ jwt_access}`
                }
            }).then(({ data }) => {
                dispatch(getClients(location, navigate));
                setClient(data);
                setModal('details');
                setPhone('');
                if(fileRef.current)
                    fileRef.current.value = null;
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }
    }

    const deleteSelection = async () => {
        dispatch(setLoading(false));
        await axios.delete(`${ endpointApi }clients?ids=${ ids.join(',') }`)
                    .then(({ data }) => {
                        setIds([]);
                        console.log(data);
                    })
                    .catch(err => {
                        setIds([]);
                        console.log(err);
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    useEffect(() => {
        if(ids.length === 0){
            checkboxRefs.current.forEach((checkbox) => {
                if(checkbox) {
                    checkbox.checked = false;
                }
            });
        }
    }, [ids]);

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Clients - Société Mikalo</title>
            </Helmet>
            
            <Header />

            <Nav />
        
            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Clients</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div ref={ modalRef } className={ `_modal${ modal === 'add' || (modal === 'update' && client) ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>{ "add" === modal ? 'Ajouter' : 'Modifier' } un client</h4>
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='pb-3'>
                                    <label htmlFor='photo'>Photo ou logo</label><br/>
                                    <input ref={ fileRef } type='file' name="photo" id="photo" accept='.png,.jpeg,.jpg' onChange={ handlePhotoChange } />
                                    { (photo.length > 0 || (client && client.photo)) && <div className='pt-2'>
                                        <div className='avatar'>
                                            <img src={ photo.length ? photo : endpoint + 'storage/' + client.photo } alt="" />
                                        </div>
                                    </div> }
                                    { errors && errors.photo && <div className='form-error'>{ errors.photo[0] }</div> }
                                </div>
                                
                                { modal === 'update' &&
                                <div className='pb-3'>
                                    <label htmlFor='code' className='required'>Code</label>
                                    <input type='text' id='code' name='code' placeholder="Code" autoComplete='off' className='form-control' required value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code client.</div> }
                                    { isCodeTouched && code.length > 0 && /^CL\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code client n'est pas valide. Le format valide est: CL/[année]/[numérro d'ordre].</div> }
                                    { errors && errors.code && <div className='form-error'>{ errors.code[0] }</div> }
                                </div> }
                                <div className='pb-3'>
                                    <label htmlFor='type' className='required'>Type</label>
                                    <select id='type' name='type' className='form-control' required value={ type } onChange={ (e) => setType(e.target.value) } onBlur={ () => setIsTypeTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="Individual">Particulier</option>
                                        <option value="Company">Entreprise</option>
                                    </select>
                                    { isTypeTouched && type.length === 0 && <div className='form-error'>Veuillez sélectionner le type de client.</div> }
                                    { errors && errors.type && <div className='form-error'>{ errors.type[0] }</div> }
                                </div>

                                { type.length > 0 && type === 'Company' &&
                                <>
                                    <h6>Entreprise</h6>
                                    <div className='pb-3'>
                                        <label htmlFor='company_name' className={ type === 'Company' ? 'required' : '' }>Nom de l'entreprise</label>
                                        <input type='text' id='company_name' name='company_name' placeholder="Nom de l'entreprise" autoComplete='off' className='form-control' required={ type === 'Company' } value={ companyName } onChange={ (e) => setCompanyName(e.target.value) } onBlur={ () => setIsCompanyNameTouched(true) } />
                                        { isCompanyNameTouched && companyName.length === 0 && <div className='form-error'>Veuillez saisir le nom de l'entreprise.</div> }
                                        { isCompanyNameTouched && companyName.length > 0 && companyName.length < 2 && <div className='form-error'>Le nom de l'entreprise est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.company_name && <div className='form-error'>{ errors.company_name[0] }</div> }
                                    </div>
                                    <div className='row'>
                                        <div className='col-12 pb-3'>
                                            <label htmlFor='rcs'>RCS</label>
                                            <input type='text' id='rcs' name='rcs' placeholder="RCS" autoComplete='off' className='form-control' value={ rcs } onChange={ (e) => setRcs(e.target.value) } onBlur={ () => setIsRcsTouched(true) } />
                                            { isRcsTouched && rcs.length > 0 && rcs.length < 2 && <div className='form-error'>Le RCS n'est pas valide.</div> }
                                            { errors && errors.rcs && <div className='form-error'>{ errors.rcs[0] }</div> }
                                        </div>
                                        <div className='col-6 pb-3'>
                                            <label htmlFor='nif'>NIF</label>
                                            <input type='text' id='nif' name='nif' placeholder="NIF" autoComplete='off' className='form-control' value={ nif } onChange={ (e) => setNif(e.target.value) } onBlur={ () => setIsNifTouched(true) } />
                                            { isNifTouched && nif.length > 0 && nif.length < 2 && <div className='form-error'>Le NIF n'est pas valide.</div> }
                                            { errors && errors.nif && <div className='form-error'>{ errors.nif[0] }</div> }
                                        </div>
                                        <div className='col-6 pb-3'>
                                            <label htmlFor='stat'>STAT</label>
                                            <input type='text' id='stat' name='stat' placeholder="STAT" autoComplete='off' className='form-control' value={ stat } onChange={ (e) => setStat(e.target.value) } onBlur={ () => setIsStatTouched(true) } />
                                            { isStatTouched && stat.length > 0 && stat.length < 2 && <div className='form-error'>Le STAT n'est pas valide.</div> }
                                            { errors && errors.stat && <div className='form-error'>{ errors.stat[0] }</div> }
                                        </div>
                                        <div className='col-12 pb-3'>
                                            <label htmlFor='cif'>CIF</label>
                                            <input type='text' id='cif' name='cif' placeholder="CIF" autoComplete='off' className='form-control' value={ cif } onChange={ (e) => setCif(e.target.value) } onBlur={ () => setIsCifTouched(true) } />
                                            { isCifTouched && cif.length > 0 && cif.length < 2 && <div className='form-error'>Le CIF n'est pas valide.</div> }
                                            { errors && errors.cif && <div className='form-error'>{ errors.cif[0] }</div> }
                                        </div>
                                    </div>
                                </> }
                                
                                { type.length > 0 && type === 'Company' && <h6>Représentant(e)</h6> }
                                <div className='pb-3'>
                                    <label htmlFor='gender' className={ type !== 'Company' ? 'required' : '' }>Civilité</label>
                                    <select id='gender' name='gender' className='form-control' required={ type !== 'Company' } value={ gender } onChange={ (e) => setGender(e.target.value) } onBlur={ () => setIsGenderTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="m">Monsieur</option>
                                        <option value="f">Madame</option>
                                    </select>
                                    { isGenderTouched && gender.length === 0 && type !== 'Company' && <div className='form-error'>{ errors.gender[0] }</div> }
                                    { errors && errors.gender && <div className='form-error'>{ errors.gender[0] }</div> }
                                </div>
                                <div className='row'>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='last_name'>Nom</label>
                                        <input type='text' id='last_name' name='last_name' placeholder='Nom' autoComplete='off' className='form-control' value={ lastname } onChange={ (e) => setLastname(e.target.value) } />
                                        { lastname.length > 0 && type !== 'Company' && lastname.length < 2 && <div className='form-error'>Le nom est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.last_name && <div className='form-error'>{ errors.last_name[0] }</div> }
                                    </div>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='first_name' className={ type !== 'Company' ? 'required' : '' }>Prénom(s)</label>
                                        <input type='text' id='first_name' name='first_name' placeholder='Prénom(s)' autoComplete='off' className='form-control' required={ type !== 'Company' } value={ firstname } onChange={ (e) => setFirstname(e.target.value) } onBlur={ () => setIsFirstnameTouched(true) } />
                                        { isFirstnameTouched && firstname.length === 0 && type !== 'Company' && <div className='form-error'>Veuillez saisir le prénom.</div> }
                                        { isFirstnameTouched && firstname.length > 0 && type !== 'Company' && firstname.length < 2 && <div className='form-error'>Le prénom est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.first_name && <div className='form-error'>{ errors.first_name[0] }</div> }
                                    </div>
                                </div>
                                { type.length > 0 && type === 'Company' && <h6>Contacts et coordonnées</h6> }
                                <div className='pb-3'>
                                    <label htmlFor='phone'>Téléphone</label>
                                    <input type='text' id='phone' name='phone' placeholder='Téléphone' autoComplete='off' className='form-control' value={ phone } onChange={ (e) => setPhone(e.target.value) } onBlur={ () => setIsPhoneTouched(true) } />
                                    { isPhoneTouched && phone.length > 0 && /^\+?[0-9]+(\s[0-9]+)*$/.test(phone) === false && <div className='form-error'>Ce numéro de téléphone n'est pas valide.</div> }
                                    { errors && errors.phone && <div className='form-error'>{ errors.phone[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='email'>Adresse e-mail</label>
                                    <input type='email' id='email' name='email' placeholder='Adresse e-mail' autoComplete='off' className='form-control' value={ email } onChange={ (e) => setEmail(e.target.value) } onBlur={ () => setIsEmailTouched(true) } />
                                    { isEmailTouched && email.length > 0 && /^[a-z0-9-.]+@[a-z0-9-.]+\.[a-z]{2,}$/i.test(email) === false && <div className='form-error'>Cette adresse e-mail n'est pas valide.</div> }
                                    { errors && errors.email && <div className='form-error'>{ errors.email[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='address'>Adresse</label>
                                    <input type='text' id='address' name='address' placeholder='Adresse' autoComplete='off' className='form-control' value={ address } onChange={ (e) => setAddress(e.target.value) } onBlur={ () => setIsAddressTouched(true) } />
                                    { isAddressTouched && address.length > 0 && address.length < 2 && <div className='form-error'>L'adresse est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.address && <div className='form-error'>{ errors.address[0] }</div> }
                                </div>
                                <div className='row'>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='zipcode'>Code postal</label>
                                        <input type='text' id='zipcode' name='zipcode' placeholder='Code postal' autoComplete='off' className='form-control' value={ zipcode } onChange={ (e) => setZipcode(e.target.value) } onBlur={ () => setIsZipcodeTouched(true) } />
                                        { isZipcodeTouched && zipcode.length > 0 && /^\d{2,}$/.test(zipcode) === false && <div className='form-error'>Le code postal n'est pas valide.</div> }
                                        { errors && errors.zipcode && <div className='form-error'>{ errors.zipcode[0] }</div> }
                                    </div>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='city'>Ville</label>
                                        <input type='text' id='city' name='city' placeholder='Ville' autoComplete='off' className='form-control' value={ city } onChange={ (e) => setCity(e.target.value) } onBlur={ () => setIsCityTouched(true) } />
                                        { isCityTouched && city.length > 0 && city.length < 2 && <div className='form-error'>Le nom de la ville est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.city && <div className='form-error'>{ errors.city[0] }</div> }
                                    </div>
                                    <div className='col-12 pb-3'>
                                        <label htmlFor='country'>Pays</label>
                                        <input type='text' id='country' name='country' placeholder='Pays' autoComplete='off' className='form-control' value={ country } onChange={ (e) => setCountry(e.target.value) } onBlur={ () => setIsCountryTouched(true) } />
                                        { isCountryTouched && country.length > 0 && country.length < 2 && <div className='form-error'>Le nom du pays est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.country && <div className='form-error'>{ errors.country[0] }</div> }
                                    </div>
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='website'>Site internet</label>
                                    <input type='url' id='website' name='website' placeholder='Site internet' autoComplete='off' className='form-control' value={ website } onChange={ (e) => setWebsite(e.target.value) } onBlur={ () => setIsWebsiteTouched(true) } />
                                    { isWebsiteTouched && website.length > 0 && /^(https?:\/\/)?(www\.)?[a-z0-9-]+\.[a-z]{2,}.*$/.test(website) === false && <div className='form-error'>Le nom du pays est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.website && <div className='form-error'>{ errors.website[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled= {
                                        type.length === 0 || (type === 'Company' && companyName.length === 0) || (type !== 'Company' && (gender.length === 0 || firstname.length < 2)) || (lastname.length > 0 && lastname.length < 2) || (phone.length > 0 && /^\+?[0-9]+(\s[0-9]+)*$/.test(phone) === false) || (email.length > 0 && /^[a-z0-9-.]+@[a-z0-9-.]+\.[a-z]{2,}$/i.test(email) === false) || (address.length > 0 && address.length < 2) || (zipcode.length > 0 && /^\d{2,}$/.test(zipcode) === false) || (city.length > 0 && city.length < 2) || (country.length > 0 && country.length < 2) || (website.length > 0 && /^(https?:\/\/)?(www\.)?[a-z0-9-]+\.[a-z]{2,}.*$/.test(website) === false) ||
                                        (photo === "" && client && "add" !== modal && type === client.type && companyName === client.company_name && (type !== 'Company' && gender === client.gender) && (lastname.length > 0 && lastname === client.last_name) && (type !== 'Company' && firstname === client.first_name) && (phone.length > 0 && phone === client.phone) && (email.length > 0 && email === client.email) && address === client.address && zipcode === client.zipcode && city === client.city && country === client.country && website === client.website)
                                    }>{ "add" === modal ? <><i className="fa fa-save"></i> Enregistrer</> : <><i className="fa fa-save"></i> Mettre à jour</> }</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && client ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { client &&
                            <h4>{ client.code }</h4> }
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { client && <>
                            <div className='mb-3'>
                                <div className='_label'>Photo</div>
                                <div className='_value'>
                                    <div className='avatar'>
                                        { client.photo ?
                                        <img src={ `${ endpoint }storage/${ client.photo }` } alt='' /> :
                                        (client.type === "Company" ? client.company_name.charAt(0) : client.first_name.charAt(0))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ client.code }</div>
                            </div>
                            { client.type === 'Company' &&
                            <>
                                <div className='mb-3'>
                                    <div className='_label'>Nom de l'entreprise</div>
                                    <div className='_value'>{ client.code }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>RCS</div>
                                    <div className='_value'>{ client.rcs }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>NIF</div>
                                    <div className='_value'>{ client.nif }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>STAT</div>
                                    <div className='_value'>{ client.stat }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>CIF</div>
                                    <div className='_value'>{ client.cif }</div>
                                </div>
                            </> }
                            <div className='mb-3'>
                                <div className='_label'>Nom de { client.type === 'Company' ? 'responsable' : 'client' }</div>
                                <div className='_value'>
                                    { client.gender && client.first_name ? 
                                    <>{ client.gender === 'f' ? 'Madame' : 'Monsieur' } { client.last_name } { client.first_name }</> : <>Non renseigné</> }
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Adresse</div>
                                <div className='_value'>{ client.address && client.zipcode && client.city && client.country ? client.address + ", " + client.zipcode + " " + client.city + ", " + client.country : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Téléphone</div>
                                <div className='_value'>{ client.phone }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>E-mail</div>
                                <div className='_value'>{ client.email ? client.email : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Site web</div>
                                <div className='_value'>{ client.website ? client.website : '-' }</div>
                            </div>
                            <div className='pt-2 text-end'>
                                <button className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className="fa fa-edit"></i> Modifier</button>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                { ids.length > 0 && 
                <div className='mb-3'>
                    <button type='button' onClick={ deleteSelection } className='btn btn-red'><i className='fa fa-trash'></i> Supprimer la sélection</button>
                </div> }

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th width="45"></th>
                                <th width="100">Code</th>
                                <th width="50px"></th>
                                <th>Entreprise</th>
                                <th>Nom et prénom</th>
                                <th>Téléphone</th>
                                <th width="75" className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        { clients.loading && <tr><td colSpan={ 7 }>Chargement...</td></tr> }
                        { clients.loading === false && clients.data && clients.data.total === 0 && <tr><td colSpan={ 7 }>Aucun élément trouvé</td></tr> }
                        { clients.loading === false && clients.data && clients.data.data && clients.data.data.map((item, index) => {
                        return (
                        <tr key={ index }>
                            <td>
                                <label>
                                    <input type='checkbox' ref={(el) => (checkboxRefs.current[index] = el)} value={ item.id } onChange={ handleCheckboxChange } />
                                    <span></span>
                                </label>
                            </td>
                            <td>{ item.code }</td>
                            <td>
                                <div className='avatar avatar-32x32'>
                                { item.photo ?
                                    <img src={ `${ endpoint }storage/${ item.photo }` } alt='' /> :
                                    (item.type === "Company" ? item.company_name.charAt(0) : item.first_name.charAt(0))
                                }
                                </div>
                            </td>
                            <td>{ item.type === 'Company' ? item.company_name : '-'}</td>
                            <td>
                                { item.gender && item.first_name ? 
                                <>{ item.gender === 'f' ? 'Madame' : 'Monsieur' } { item.last_name } { item.first_name }</> : <>Non renseigné</> }
                            </td>
                            <td>{ item.phone ? item.phone : 'Non renseigné' }</td>
                            <td className="text-end">
                                <div className='actions'>
                                    <button type='button' className='toggle-action' onClick={ (e) => {
                                    e.stopPropagation();
                                    setActionModal(actionModal !== item.id ? item.id : null);
                                    } }><i className='fa fa-ellipsis-v'></i></button>
                                    <ul className={ actionModal === item.id ? 'active' : '' }>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setModal("details");
                                            setClient(item);
                                        } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                        <li><button type='button' onClick={ () => {
                                            setModal("update");
                                            setActionModal(null);
                                            setClient(item);
                                        } }><i className="fa fa-edit"></i> Modifier</button></li>
                                    </ul>
                                </div>
                            </td>
                        </tr> ) })}
                        </tbody>
                    </table>
                </div>

                { clients && clients.data &&
                <Paginate currentPage={ clients.data.current_page } totalPages={ clients.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
